enum EStoreStateKeys {
  user = 'user',
  settings = 'settings',
  agent = 'agent',
  chatbot = 'chatbot',
  conversation = 'conversation',
  organization = 'organization',
  UIElements = 'UIElements',
}

export default EStoreStateKeys
